import React from "react";

const RewardListContext = React.createContext({
  rewards: {},
  setRewards: () => {},
});

export default RewardListContext;
